import Home from "../home/Home";
import { Routes, Route } from "react-router-dom";
import NewsItem from "../news/NewsItemView";
import News from "../news/NewsView";
import Reporting from "../reporting/Reporting";
import CMS from "../cms/CMS";
import { hasAdminRole, hasFormsRole, hasPrintRole, hasECAdminRole, hasVolunteerRole } from "../utils";
import GuardedRoute from "./GuardedRoute";
import PageItemView from "../pages/PageItemView";
import Events from "../events/Events";
import EventList from "../events/EventList";
import EventDetails from "../events/EventDetails";
import ConstituentList from "../events/ConstituentList";
import Orders from "../orders";
import Order from "../orders/order";
import MailPull from "../list-builder/MailPull";
import MailPullStatus from "../list-builder/MailPullStatus";
import PrintView from "../print/PrintView";
import NoMatch from "./NoMatch";
import FormsView from "../forms/FormsView";
import FormView from "../form/FormView";
import FormDetailsView from "../forms/FormDetailsView";
import FormSubmissionView from "../forms/FormSubmissionView";
import ChapterDetails from "../chapters/ChapterDetails";
import useOrgRoles from "../hooks/useOrgRoles";
// available portal roles: volunteer_portal:ecadmin,volunteer_portal:print,volunteer_portal:forms,volunteer_portal:admin
const DuckRouter = () => {
  const roles = useOrgRoles();
  const isAdmin = hasAdminRole(roles) || hasECAdminRole(roles);
  const isPrint = hasPrintRole(roles);
  const isForms = hasFormsRole(roles);
  const isVolunteer = hasVolunteerRole(roles);
  console.log('Rendering DuckRouter');
  return (
    <Routes>
      <Route path="*" element={<NoMatch />} />
      <Route path="/" element={<Home />} />
      <Route path="/news/:id" element={<NewsItem />} />
      <Route path="/page/:slug" element={<PageItemView />} />
      <Route path="/news" element={<News />} />
      <Route path="/events" element={<Events />} />
      <Route path="/events/:chapterId" element={<EventList />} />
      <Route path="/event/mail-pull/result/:eventId" element={<MailPullStatus />} />
      <Route path="/event/mail-pull/:eventId" element={<MailPull />} />
      <Route path="/event/" element={<EventDetails />} />
      <Route path="/chapter/:chapterId/:chapterName" element={<ChapterDetails />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/order/:orderId" element={<Order />} />
      <Route path="/constituents/:eventId" element={<ConstituentList />} />
      <Route path="/reports/event/" element={
          <GuardedRoute auth={isVolunteer}>
            <Reporting />
          </GuardedRoute>
        } />
      <Route
        path="/admin/*"
        element={
          <GuardedRoute auth={isAdmin}>
            <CMS />
          </GuardedRoute>
        }
      />
      <Route
        path="/print"
        element={
          <GuardedRoute auth={isPrint}>
            <PrintView />
          </GuardedRoute>
        }
      />
      <Route
        path="/forms"
        element={
          <GuardedRoute auth={isForms}>
            <FormsView />
          </GuardedRoute>
        }
      />
      <Route
        path="/formssubmission/:submissionId"
        element={
          <GuardedRoute auth={isForms}>
            <FormSubmissionView />
          </GuardedRoute>
        }
      />
      <Route
        path="/forms/:formId"
        element={
          <GuardedRoute auth={isForms}>
            <FormDetailsView />
          </GuardedRoute>
        }
      />
      <Route path="/form/:formId" element={<FormView />} />
    </Routes>
  );
};

export default DuckRouter;
